import React from "react";
import { Routes, Route } from "react-router-dom";
import { DocumentationRoutes } from "../src/routes/DocumentationRoutes";
import { Scope1Routes } from "../src/routes/Scope1Routes";
import { Scope2Routes } from "../src/routes/Scope2Routes";
import { Scope3Routes } from "../src/routes/Scope3Routes";
import { Scope4Routes } from "../src/routes/Scope4Routes";
import { SocialRoutes } from "../src/routes/SocialRoutes";
import { GovernanceRoutes } from "../src/routes/GovernanceRoutes";
import { MiscRoutes } from "../src/routes/MiscRoutes";
import { ApporvalRoutes } from "../src/routes/ApporvalRoutes";
import { ValueChainRoutes } from "../src/routes/ValueChainRoutes";
import { BRSRRoutes } from "../src/routes/BRSRRoutes";
import { GRIRoutes } from "../src/routes/GRIRoutes";
import { MainRoutes } from "../src/routes/MainRoutes";
import { MastersRoutes } from "../src/routes/MastersRoutes";
import { InitialQuestionareRoutes } from "../src/routes/InitialQuestionareRoutes";
import NotFound from "./Pages/404/NotFound";
import { SSORoutes } from "./routes/SSORoutes";

function Home() {
  const allRoutes = [
    ...DocumentationRoutes,
    ...Scope1Routes,
    ...Scope2Routes,
    ...Scope3Routes,
    ...Scope4Routes,
    ...SocialRoutes,
    ...GovernanceRoutes,
    ...MiscRoutes,
    ...ApporvalRoutes,
    ...ValueChainRoutes,
    ...BRSRRoutes,
    ...GRIRoutes,
    ...MainRoutes,
    ...MastersRoutes,
    ...InitialQuestionareRoutes,
    ...SSORoutes,
  ];
  return (
    <Routes>
      {allRoutes.map((route, i) => {
        return <Route key={i} path={route.path} element={route.element} />;
      })}
      {/* <Route   path= "*" element={ <NotFound />} /> */}
    </Routes>
  );
}

export default Home;
